import { useQuery, useQueryClient } from "@tanstack/react-query";
import LabelledDivRow from "components/LabelledDivRow";
import React from "react";
import EllipsisLoading from "./EllipsisLoading";

interface Props {
  redis: server.dto.RedisDiagnostic
}

const RedisRows = ({ redis }: Props) => {
  const redisPingQuery = useQuery({
    queryFn: async () => window.CoreApi.AdminOne.GetRedisPing().then(r => r.data),
    queryKey: ["redisPing"]
  });

  const queryClient = useQueryClient();
  const retry = async () => queryClient.invalidateQueries(["redisPing"]);

  return <>
    <LabelledDivRow label="Cache enabled">
      <div>{redis.cacheEnabled.toString()}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Server">
      <div style={{ overflowWrap: "anywhere" }}>{redis.server}</div>
    </LabelledDivRow>
    <LabelledDivRow label="SSL">
      <div>{redis.ssl.toString()}</div>
    </LabelledDivRow>
    <LabelledDivRow label="Ping">
      <div>
        {redisPingQuery.isFetching && <EllipsisLoading text="loading" />}
        {redisPingQuery.isError && <div>error</div>}
        {(redisPingQuery.data && !redisPingQuery.isFetching) && <div>{redisPingQuery.data.data}</div>}
        <a onClick={retry}>Retry</a>
      </div>
    </LabelledDivRow>
  </>;
};

export default RedisRows;